const getNameInitials = (name: string) =>
  name
    ?.split(' ')
    .map((word) => word[0])
    .join('');

export default getNameInitials;
